
import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components/layout/FlexLayout';
import { AreaModel } from '../models';
import { BreakAnalysisOne } from '../BreakAnalysisOne';
import { TextBox } from '../../../../../components';

// 지역별
const Area: GridLayoutHeader<AreaModel, BreakAnalysisOne>[] = [
  {
    id: 'areanm',
    text: '지역별',
    width: 100,
    trail: () => (
      <FlexLayout
        justify="left"
        align="center"
      >
        총계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.areanm}
      </FlexLayout>
    ),
  },
  {
    id: 'cnt',
    text: '고장건수',
    width: 200,
    render: (x) => (
      <TextBox
        textAlign="center"
        value={x.cnt}
      />
    ),
  },
];

export default Area;
